<div
  class="flex flex-col h-full w-full p-3 max-h-full border-box overflow-hidden max-w-full px-8"
>
  <div class="w-full max-w-full block sm:h-fit">
    <app-plant-details [categoryId]="'1'"></app-plant-details>
  </div>

  <div
    class="flex flex-wrap justify-between sm:gap-3 lg:gap-1.5 sm:mt-1 lg:mt-[1%] items-center flex-grow overflow-auto w-full"
  >
    <div
      class="lg:w-[66.2%] lg:h-[48.5%] lg:min-h-[310px] lg:m-[0.1%] sm:w-full sm:py-6 sm:px-5 lg:py-4 lg:px-4 sm:h-[25.1rem] md:h-[25.5rem] md:w-full bg-[#252A30] flex flex-col rounded-2xl border-box text-white"
    >
      
      <div class="lg:pt-2 sm:pt-0.5">
        <span class="text-base font-medium text-white">{{
          "solar_plant" | translate
        }}</span>
      </div>
      <div
        class="mt-8 sm:flex-grow md:flex-grow-0 lg:flex-grow flex sm:justify-center md:justify-start"
      >
        <div class="lg:w-full lg:h-full sm:h-full sm:w-full">
          <!-- Data -->
          <div class="h-fit flex w-full">
            <div class="pr-6 sm:w-[20%] xl:w-[16%] xxl:w-[18%] md:w-[25%]">
              <div class="flex items-center pb-3">
                <span class="font-medium text-xl pr-3 text-white">{{
                  allplantDetails.solarPlantResponse.totalSolarPlants
                }}</span>
                <img
                  class="w-7 h-7 ml-4"
                  src="../../../../../assets/images/hdimg.svg"
                  alt="hdimg"
                />
              </div>

              <!-- Status -->
              <div class="flex flex-col pb-6">
                <span class="text-sm flex-1 pb-2 mt-2 text-dark-gray-content"
                  >Status</span
                >
                <div class="flex items-center gap-2">
                  <div>
                    <img src="../../../../../assets/svg/green-img.svg" alt="Online"/>
                  </div>
                  <span class="text-base pl-2">
                    {{ allplantDetails.solarPlantResponse.solarPlantsOnline }}
                  </span>
                </div>
                <div class="flex items-center gap-2 mt-2">
                  <div><img src="../../../../../assets/svg/red-img.svg" alt="Offline"/></div>
                  <span class="text-base pl-2">
                    {{
                      allplantDetails.solarPlantResponse.solarPlantsOffline
                    }}</span
                  >
                </div>
              </div>
            </div>

            <!-- Insights -->
            <div
              class="flex justify-between sm:w-[80%] lg:pr-7 xl:pl-0 xxl:w-[69%] xl:w-[75%] md:w-[70%]"
            >
              <div class="">
                <div class="flex flex-col pb-4">
                  <span
                    class="text-sm text-card-text pb-2 text-dark-gray-content"
                    >{{ "current_generation" | translate }}</span
                  >
                  <span class="text-[18px] text-white font-normal mt-3"
                    >{{ allplantDetails.solarPlantResponse.currentGeneration }}
                  </span>
                </div>
                <div class="flex flex-col">
                  <span
                    class="text-sm text-card-text pb-2 text-dark-gray-content"
                    >{{ "lifetime_saving" | translate }}</span
                  >
                  <span class="text-[18px] text-white font-normal mt-3">
                    {{
                      convertScientificNotation(
                        allplantDetails.solarPlantResponse.lifetimeSavings.toString(),
                        "lifetimeSavings"
                      )
                    }}</span
                  >
                </div>
              </div>
              <div class="">
                <div class="flex flex-col pb-4">
                  <span
                    class="text-sm text-card-text pb-2 text-dark-gray-content"
                    >{{ "today_generation" | translate }}</span
                  >
                  <span class="text-[18px] text-white font-normal mt-3">
                    {{
                      allplantDetails.solarPlantResponse.todayGeneration
                    }}</span
                  >
                </div>
                <div class="flex flex-col">
                  <span
                    class="text-sm text-card-text pb-2 text-dark-gray-content"
                    >{{ "return_on_investment" | translate }}</span
                  >
                  <span class="text-[18px] text-white font-normal mt-3">
                    {{
                      allplantDetails.solarPlantResponse.roi > 100
                        ? 100
                        : allplantDetails.solarPlantResponse.roi
                    }}%</span
                  >
                </div>
              </div>
              <div class="">
                <div class="flex flex-col pb-4">
                  <span
                    class="text-sm text-card-text pb-2 text-dark-gray-content"
                    >{{ "lifetime_generation" | translate }}</span
                  >
                  <span class="text-[18px] text-white font-normal mt-3">
                    {{
                      allplantDetails.solarPlantResponse.lifetimeGeneration
                    }}</span
                  >
                </div>
                <div class="flex flex-col">
                  <span
                    class="text-sm text-card-text pb-2 text-dark-gray-content"
                  >
                    {{ "total_solar_capacity" | translate }}</span
                  >
                  <span class="text-[18px] text-white font-normal mt-3">
                    {{
                      allplantDetails.solarPlantResponse.totalSolarCapacity
                    }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Environmental Benefits -->
      <div
        class="items-end sm:gap-4 lg:gap-0 md:flex-grow lg:flex-grow-0 sm:mt-8 lg:mt-0"
      >
        <div>
          <span class="text-dark-gray-content pb-2">
            {{ "environment_benefits" | translate }}</span
          >
        </div>

        <div
          class="flex pt-2 md:mt-7 lg:mt-0 sm:items-center sm:justify-between lg:px-unset sm:px-8 w-full lg:items-start md:flex-grow lg:flex-grow-0"
        >
      
          <div
            class="flex sm:flex-col md:flex-row sm:justify-start md:items-center lg:gap-1 xl:gap-2"
          >
            <div>
              <img
                class="xl:w-10 xl:h-10 sm:h-6 sm:w-6 md:w-[34px] md:h-[34px]"
                src="../../../../../assets/svg/equivalent_trees_planted.svg"
                alt="Trees Icon"
              />
            </div>
            <div
              class="flex sm:flex-col lg:items-center flex-wrap lg:flex-row lg:gap-0"
            >
              <div class="lg:ml-1 xl:ml-0">
                <span
                  class="text-white text-[16px] text-nowrap font-normal pt-1 md:pt-0"
                >
                  {{
                    allplantDetails.solarPlantResponse.equivalentTreesPlanted
                  }}</span
                >
              </div>
              <div class="xl:ml-2 lg:ml-1">
                <span
                  class="text-xs lg:text-md text-dark-gray-content lg:text-nowrap"
                  >{{ "equivalent_trees_planted" | translate }}</span
                >
              </div>
            </div>
          </div>
        
          <div
            class="flex sm:flex-col md:flex-row md:items-center sm:justify-start lg:gap-1 xl:gap-2 lg:pl-0.5 xl:pl-0 xl:ml-3"
          >
            <div>
              <img
                class="xl:w-10 xl:h-10 sm:h-7 sm:w-7 md:w-[34px] md:h-[34px]"
                src="../../../../../assets/svg/co2_emission_saved.svg"
                alt="Trees Icon"
              />
            </div>
            <div class="flex sm:flex-col lg:flex-row flex-wrap lg:items-center">
              <div class="lg:ml-1 xl:ml-0">
                <span
                  class="text-white text-[16px] font-normal pt-1 md:pt-0 text-nowrap"
                >
                  {{
                    convertScientificNotation(
                      allplantDetails.solarPlantResponse.co2EmissionSaved
                    )
                  }}</span
                >
              </div>
              <div class="xl:ml-2 lg:ml-1">
                <span
                  class="text-xs lg:text-md text-dark-gray-content text-nowrap"
                  >CO<sub>2</sub> Emission Saved</span
                >
              </div>
            </div>
          </div>
         
          <div
            class="flex sm:flex-col md:flex-row md:items-center sm:justify-start lg:gap-1 xl:gap-2 lg:pl-0.5 xl:pl-0 xl:ml-3"
          >
            <div>
              <img
                class="xl:w-10 xl:h-10 sm:h-6 sm:w-6 md:w-[34px] md:h-[34px]"
                src="../../../../../assets/svg/coal_not_burnt.svg"
                alt="Trees Icon"
              />
            </div>
            <div class="flex sm:flex-col lg:flex-row flex-wrap lg:items-center">
              <div class="lg:ml-1 xl:ml-0">
                <span
                  class="text-white text-[16px] font-normal pt-1 md:pt-0 text-nowrap"
                >
                  {{ allplantDetails.solarPlantResponse.coalNotBurned }}</span
                >
              </div>
              <div class="xl:ml-2 lg:ml-1">
                <span
                  class="text-xs lg:text-md text-dark-gray-content text-nowrap"
                  >{{ "coal_not_burned" | translate }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div
      class="flex flex-col lg:w-[15.8%] lg:h-[48.5%] sm:h-[15.9rem] md:h-[17rem] rounded-2xl lg:m-[0.2%] lg:min-h-[310px] sm: bg-[#252A30] border-box text-white sm:py-6 sm:px-5 lg:py-4 lg:px-4 sm:w-[49%] md:w-[49.31%]"
    >
      <div class="text-base font-medium text-white lg:pt-2 sm:pt-0.5">
        <span class="text-base text-white">
          {{ "non_solar_plant" | translate }}</span
        >
      </div>
      <div class="w-full flex flex-col flex-grow lg:pt-8 sm:pt-4">
        <div class="flex flex-row items-center">
          <div>
            <p class="text-xl font-medium">
              {{ allplantDetails.nonSolarPlantResponse.totalNonSolarPlants }}
            </p>
          </div>

          <div class="flex justify-center items-center sm:ml-20 xl:ml-16">
            <img
              src="../../../../../assets/images/nonsolarrr.svg"
              class="img-sm h-12"
              alt="plant"
            />
          </div>
        </div>
        <div class="flex flex-col flex-wrap lg:mt-8 sm:mt-7 md:mt-4 flex-grow">
          <div class="flex justify-start items-start">
            <p class="text-lg font-normal text-dark-gray-content">
              {{ "status" | translate }}
            </p>
          </div>
          <div
            class="flex flex-col status flex-grow lg:mt-[3%] xxl:mt-2.5 sm:mt-1 md:mt-0"
          >
            <div class="flex md:justify-start items-center subfirst">
              <img src="../../../../../assets/svg/green-img.svg" alt="online" />

              <span class="value-small pl-5"
                >{{
                  allplantDetails.nonSolarPlantResponse.nonSolarPlantsOnline
                }}
              </span>
            </div>

            <div
              class="flex lg:justify-start items-center sm:mt-3 md:mt-1.5 lg:mt-1.5 xxl:mt-2"
            >
              <div>
                <img
                  src="../../../../../assets/svg/red-img.svg"
                  alt="offline"
                />
              </div>
              <div class="pl-5">
                <span class="value-small"
                  >{{
                    allplantDetails.nonSolarPlantResponse.nonSolarPlantsOffline
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div
      class="flex flex-col lg:w-[15.8%] lg:h-[48.5%] sm:h-[15.9rem] md:h-[17rem] rounded-2xl lg:m-[0.2%] lg:min-h-[310px] bg-[#252A30] border-box text-white sm:py-6 sm:px-5 lg:py-4 lg:px-4 sm:w-[49%] md:w-[49.31%]"
    >
      <div class="text-base font-medium text-white lg:pt-2 sm:pt-0.5">
        <span class="text-base text-white">{{ "bms_plant" | translate }}</span>
      </div>
      <div class="w-full flex flex-col flex-grow lg:pt-8 sm:pt-4">
        <div class="flex flex-row items-center">
          <div>
            <p class="text-xl font-medium">
              {{ allplantDetails.bmsPlantResponse.totalBmsPlants }}
            </p>
          </div>

          <div class="flex justify-center items-center sm:ml-20 xl:ml-16">
            <img
              src="../../../../../assets/images/bms_plant.svg"
              class="img-sm h-12"
              alt="plant"
            />
          </div>
        </div>
        <div class="flex flex-col flex-wrap lg:mt-8 flex-grow sm:mt-7 md:mt-4">
          <div class="flex justify-start items-start">
            <p class="text-lg font-normal text-dark-gray-content">
              {{ "status" | translate }}
            </p>
          </div>
          <div
            class="flex flex-col status flex-grow lg:mt-[3%] xxl:mt-2.5 sm:mt-1 md:mt-0"
          >
            <div class="flex md:justify-start items-center subfirst">
              <img src="../../../../../assets/svg/green-img.svg" alt="online" />

              <span class="value-small pl-5">{{
                allplantDetails.bmsPlantResponse.bmsPlantsOnline
              }}</span>
            </div>

            <div
              class="flex lg:justify-start items-center sm:mt-3 md:mt-1.5 lg:mt-1.5 xxl:mt-2"
            >
              <div>
                <img
                  src="../../../../../assets/svg/red-img.svg"
                  alt="offline"
                />
              </div>
              <div class="pl-5">
                <span class="value-small">{{
                  allplantDetails.bmsPlantResponse.bmsPlantsOffline
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div
      class="lg:w-[32.7%] lg:h-[48.5%] flex flex-col text-white lg:min-h-[310px] m-[0.1%] lg:m-unset border-box sm:h-[18.5rem] md:w-full md:h-[20rem] sm:w-full bg-[#252A30] rounded-2xl sm:py-6 sm:px-5 lg:py-4 lg:px-4"
    >
      <div class="flex items-center lg:pt-2 sm:pt-0.5">
        <div class="h-full">
          <span class="text-base font-medium text-white">
            {{ "plant_health" | translate }}</span
          >
        </div>

        <img
          src="../../../../assets/images/info-icon.svg "
          class="ml-2 hidden"
          alt="Info"
        />
      </div>

      <div
        class="flex flex-row w-full h-full justify-center items-center sm:pt-1 md:pt-0 flex-grow"
      >
        <div
          class="flex flex-col justify-center items-center w-[30%] planttitle"
        >
          <div class="sm:w-[65%] md:w-[60%] lg:w-unset">
            <app-radial-bar
              [dataLabel]="'Healthy'"
              [dataSeries]="plantHealthDetails.solarPlantsHealth"
              [maxSize]="130"
            ></app-radial-bar>
          </div>
          <div
            class="headingbox sm:mt-[6%] lg:mt-[6%] md:mt-1.5 text-center items-center flex flex-col"
          >
            <div>
              <p class="value-medium">
                {{ allplantDetails.solarPlantResponse.totalSolarPlants }}
              </p>
            </div>
            <div>
              <p class="text-lg text-dark-gray-content">
                {{ "solar" | translate }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="flex flex-col items-center justify-center w-[30%] planttitle"
        >
          <div class="sm:w-[65%] md:w-[60%] lg:w-unset">
            <app-radial-bar
              [dataLabel]="'Healthy'"
              [dataSeries]="plantHealthDetails.nonSolarPlantsHealth"
              [maxSize]="130"
            ></app-radial-bar>
          </div>
          <div
            class="headingbox sm:mt-[6%] lg:mt-[6%] md:mt-1.5 text-center items-center flex flex-col"
          >
            <div class="">
              <p class="value-medium">
                {{ allplantDetails.nonSolarPlantResponse.totalNonSolarPlants }}
              </p>
            </div>
            <div>
              <p class="text-lg text-dark-gray-content">
                {{ "non_solar" | translate }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="flex flex-col items-center justify-center w-[30%] planttitle"
        >
          <div class="sm:w-[65%] md:w-[60%] lg:w-unset">
            <app-radial-bar
              [dataLabel]="'Healthy'"
              [dataSeries]="plantHealthDetails.bmsPlantsHealth"
              [maxSize]="130"
            ></app-radial-bar>
          </div>
          <div
            class="headingbox sm:mt-[6%] lg:mt-[6%] md:mt-1.5 text-center flex flex-col items-center"
          >
            <div>
              <p class="value-medium">
                {{ allplantDetails.bmsPlantResponse.totalBmsPlants }}
              </p>
            </div>
            <div>
              <p class="text-lg text-dark-gray-content">
                {{ "bms" | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <div
      class="lg:w-[32.7%] lg:h-[48.5%] bg-[#252A30] rounded-2xl sm:h-[19rem] lg:min-h-[310px] lg:m-[0.1%] sm:max-h-fit md:w-[49.31%] md:h-[21rem] md:max-h-fit sm:py-6 sm:px-5 lg:py-4 lg:px-4 border-box sm:w-full"
    >
      <app-powercut-and-summary [categoryId]="'1'"></app-powercut-and-summary>
    </div>
    
    <div
      class="lg:w-[32.7%] lg:h-[48.5%] bg-[#252A30] rounded-2xl sm:h-[19rem] lg:min-h-[310px] lg:m-[0.1%] sm:max-h-fit md:w-[49.31%] md:h-[21rem] md:max-h-fit sm:py-6 sm:px-5 lg:py-4 lg:px-4 border-box sm:w-full"
    >
      <app-today-alerts [categoryId]="'1'"> </app-today-alerts>
    </div>
  </div>
</div>
